<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="QuotationOrderConfirmTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" :show_close="true" :show_close_cancel="true"
        @on_query="on_query" :show_toolbar_button="[0, 0, 1, 1, 0, 0, 0, 1]"
        :hb_table_class="'hb_table_weight_cost_confirm_class1'" @tool_invoke="tool_invoke" @state_change="state_change" tableref="bde5b6cb89d945abaf8132e59b2a7f1c">
        <template #query>
          <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
            align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            :picker-options="pickerOptions()">
          </el-date-picker>
          <el-select placeholder="销售公司" size="small" v-model="dataAreaId" filterable clearable class="w-10 ml-1">
            <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
              :label="item.DataArea + ':' + item.CompanyName" :value="item.DataArea"></el-option>
          </el-select>
          <el-input placeholder="客户名称" class="ml-1" clearable size="small" style="width: 180px"
            v-model="CustName"></el-input>
          <el-select placeholder="请输入报价申请编号关键词" size="small" v-model="QuotationTaskNum" filterable remote
            reserve-keyword :remote-method="QTRemoteMethod" clearable @clear="QTRemoteMethod('')"
            @focus="QTRemoteMethod('')" class="w-10 ml-1">
            <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
          </el-select>
        </template>
        <template #toolbar>
          <el-button type="danger" plain @click="OtherCostEdit('other_cost')"
            class="ml-2 iconfont icon-bangongshichengben" size="mini">
            其它费用
          </el-button>
          <el-button type="danger" plain @click="OtherCostEdit('exchange_rate')" class="ml-2 iconfont icon-edit"
            size="mini">
            汇率
          </el-button>
          <el-button type="primary" plain @click="updatePriceSuggest" class="ml-2 iconfont icon-edit" size="mini">
            更新建议销售价
          </el-button>
          <div style="display: inline-block">
            <el-checkbox-group style="display: inline-block" class="ml-2" v-model="checkedConditions"
              @change="only_methods">
              <el-checkbox v-for="(item, index) in onlyCheckOptions" :label="item.value" :key="index">{{ item.label
                }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 其他费用/汇率 -->
    <el-dialog :title="edit_action_code == 'other_cost' ? '其他费用' : '汇率'" :visible.sync="accessoryVisible" width="30%"
      :top="'10vh'" :close-on-click-modal="false" @opened="dialogOpened">
      <el-form :label-position="'right'" label-width="120px" :model="formLabelAlign">
        <el-form-item v-for="(item, index) in detail_othercost_data" :key="index"
          :label="item.CostName ? item.CostName : item.label" class="mb-0">
          <el-input v-if="item.type_code == 'other_cost'" v-model="item.TransportCost" type="number"
            style="width:80%"></el-input>
          <el-input v-if="item.type_code == 'exchange_rate'" v-model="item.ExchangeRate" type="number"
            style="width:80%"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="accessoryVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogClosed">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as QuotationOrderController from "../../controllers/sd/QuotationOrderController"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      date_picker_label: "",
      date_range: [this.$date.addMonths(new Date(), -6), new Date()],
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "weighted_cost_confirm",
      },
      fields: _.cloneDeep(QuotationOrderController.fields.weighted_cost_confirm),
      ItemId: "",
      isBusy: false,
      dataAreaId: "",
      CustName: "",
      QuotationTaskNum: "",
      QTOptions: [],
      accessoryVisible: null,
      edit_action_code: '',
      detail_othercost_data: [],
      formLabelAlign: null,
      all_role_users: [],
      hisData: [],
      checkedConditions: [1],
      onlyCheckOptions: [
        { value: 1, label: "仅待审批" },
        { value: 2, label: "仅已审批" }
      ],
    }
  },
  async created() {
    await this.getAllRoleUsers()
    await this.on_query(this.$refs.QuotationOrderConfirmTable1.SetData)
  },
  watch: {
    "$route": {
      handler(val) {
        if (val) {
          if (val.query.k) {
            this.QuotationTaskNum = val.query.k
            this.on_query(this.$refs.QuotationOrderConfirmTable1.SetData)
          }
        }
      },
      deep: true
      // immediate: true
    },
  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    ///获取报价申请编号
    async getKvQuoteTask(query = '') {
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = { like: "%" + query + "%" }
      let _result = await QuotationTaskController.methods.getData(p, "kv")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_.filter(_result[0], { fcCheckSQOApproved: true }), (t) => {
          return { value: t.QuotationTaskNum, label: t.dataAreaId + ":" + t.QuotationTaskNum }
        })
        this.QTOptions = _.orderBy(dt.slice(0, 300), ["value"], ["desc"])
      }
    },
    ///报价申请编号下拉
    async QTRemoteMethod(query) {
      await this.getKvQuoteTask(query)
    },
    //#region 查询
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }
      let hasDate = true
      let p = { IsAllDisApproved: 1 }
      if (this.dataAreaId != "") {
        p.dataAreaId = this.dataAreaId
        hasDate = false
      }
      if (this.CustName != "") {
        p.CustName = _.trim(this.CustName)
        hasDate = false
      }
      if (this.QuotationTaskNum && this.QuotationTaskNum != "") {
        p.QuotationTaskNum = _.trim(this.QuotationTaskNum)
        hasDate = false
      }
      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p.date_from = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        p.date_to = _toDate
      }
      let _result = await QuotationOrderController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_result[0], { fcCheckSQODApproved: true })

        for (var i in dt) {
          if (!_.isNull(dt[i].SalesQuoteWeightCostApprover) && dt[i].SalesQuoteWeightCostApprover)
            dt[i]._SalesQuoteWeightCostApprover = dt[i].SalesQuoteWeightCostApprover.split(",")[0]
          this.getApprover(dt[i])
          if (dt[i].SalesQuoteWeightCostApproved)
            dt[i].SalesQuoteWeightCostApprover = dt[i].approved_by_username
          dt[i]._error = dt[i].is_price_update
          dt[i]._error_color = '#409EFF'
        }
        this.hisData = dt
        this.only_methods(this.checkedConditions)
      }
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "SalesQuoteWeightCostApprover",
        "SalesQuoteWeightCostApprover",
        t.SalesQuoteWeightCostApproved,
        true
      )
    },
    only_methods(v) {
      let checkedValue = _.last(v)
      this.checkedConditions = [checkedValue]
      let dt = _.cloneDeep(this.hisData)

      if (checkedValue == 1) {///未审批
        dt = _.filter(dt, { isWeightedCostAllConfirm: false })
      }
      else if (checkedValue == 2) {///已审批
        dt = _.filter(dt, { isWeightedCostAllConfirm: true })
      }

      this.$refs.QuotationOrderConfirmTable1.SetData(_.orderBy(dt, ["QuotationTaskNum"], ["desc"]))
    },
    //#endregion

    //#region 状态切换/确认
    async state_change(data, cb) {
      let msg = ""
      if (data.selected_items.length == 0)
        msg = this.$t("notify.not_data")
      else if (_.findIndex(data.selected_items, { fcCheckSQOrderApproved: true }) > -1)
        msg = "报价单已审批，不能执行该操作！"

      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }

      ///检查是否有该权限
      let check_ap_res = []
      let _check_ap_params = {
        list: _.map(data.selected_items, (t) => { return { id: t.quotationtask_detail_id } }),
        DocumentType: "SalesQuoteWeightCost",
        approve_type: "",
        isNotCheckPrivilage: data.state == "approved" ? false : true,
        action_state: data.state == "approved",
      }
      check_ap_res = await commonController.methods.checkApprovePrivilige(_check_ap_params, this)
      if (check_ap_res.notPriviligeIdList.length > 0 || check_ap_res.approveStatusIdList.length == 0) {
        this.msgToasts("抱歉，暂无审批权限！", "error")
        cb(false)
        return
      }
      if (data.state == "approved" || data.state == "unapproved") {
        let p = { edit: [], approved: [], weight_cost_confirm: [], quote_order_approved: [], local_username: this.$global.global_data.local_username }
        _.each(data.selected_items, (t) => {
          t.is_approved = data.state == "approved"
          let m = {
            id: t.quotationtask_detail_id,
            WeightedCost: t.WeightedCost,//加权成本
            TargetGrossProfitMargin: t.TargetGrossProfitMargin,//目标毛利率
            GrossProfitMargin: t.GrossProfitMargin //毛利率
          }
          if (!t.is_approved) {
            m = {
              id: t.quotationtask_detail_id,
              WeightedCost: 0,
              TargetGrossProfitMargin: 0,
              GrossProfitMargin: 0
            }
          }
          p.edit.push(m)
          p.approved.push({ id: t.quotationtask_detail_id, is_approved: t.is_approved, })
          p.weight_cost_confirm = check_ap_res.approveStatusIdList
          let IsExists = _.some(p.quote_order_approved, { itemId: t.quotationtask_detail_id })
          if (!IsExists && data.state == "approved")
            p.quote_order_approved.push({
              itemId: t.quotationtask_detail_id,
              documentCreateByUsername: t.create_by_username,
              is_factory: t.IsHomemade != 2 ? 1 : 0,//自制或外购
              LtTargetProfit: t.GrossProfitMargin //毛利
            })
        })

        let confirm_m = await this.$prompt('请输入审批原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\S\s]+$/,
          inputErrorMessage: '请输入原因',
          inputValue: "同意"
        }).then(({ value }) => {
          return { state: true, val: value }
        }).catch(() => {
          return { state: false }
        })
        if (confirm_m && confirm_m.state) {
          p.ApproveRemark = confirm_m.val
        }
        else return

        let rt = await QuotationTaskController.methods.saveDetailData(p)
        if (rt) {
          if (data.state == "approved")
            await this.SendEmail(data.selected_items)
          await this.on_query(this.$refs.QuotationOrderConfirmTable1.SetData, false)
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          cb(true)
        }
        else {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          cb(false)
        }
      }
      else if (data.state == "refused") {
        let dt = this.$refs.QuotationOrderConfirmTable1.GetSelectedItems()
        if (_.findIndex(dt, (t) => t.SalesQuoteWeightCostApproved) > -1) {
          this.msgToasts("已审批数据，不能执行该操作！", "info")
          return
        }

        if (dt.length > 0)
          await this.RefusedToPurch(dt)
      }
      else if (data.state == "closed") {
        if (data.selected_items.length == 0) {
          this.msgToasts(this.$t("notify.not_data"), "info")
          return
        }
        if (_.findIndex(data.selected_items, (t) => t.closed == 1 || t.closed == 2) > -1) {
          this.msgToasts("已关闭或发送关闭申请，不能重复执行该操作！", "info")
          return
        }
        let v = await this.msgModal(this.$t("notify.is_continue"))
        if (v) {
          let confirm_m = await this.$prompt('请输入关闭原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\S\s]+$/,
            inputErrorMessage: '请输入原因',
            inputValue: ""
          }).then(({ value }) => {
            return { state: true, val: value }
          }).catch(() => {
            return { state: false }
          })
          if (confirm_m && confirm_m.state) { }
          else return

          let dt = _.map(data.selected_items, (t) => {
            return {
              QuotationTaskDetailId: t.quotationtask_detail_id,
              Description: confirm_m.val
            }
          })
          let _result = await QuotationTaskController.methods.addQuoteCloseApplication(dt)
          if (!_.isNull(_result) && _result && _result.length > 0) {
            //关闭时给报价申请发送关闭申请邮件
            let _dt = _.map(_.cloneDeep(data.selected_items), (t) => {
              t.CloseDescription = confirm_m.val
              t.CloseUserName = this.$global.global_data.local_username
              t.CloseDate = this.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss")
              switch (t.IsHomemade) {
                case 0: t.IsHomemade = '否'; break
                case 1: t.IsHomemade = '是'; break
                case 2: t.IsHomemade = '纯外协'; break
              }
              return t
            })
            let email_data = _.groupBy(_dt, "create_by_username")
            await commonController.handleEmailData(email_data, "quote_order_closed", this)
            await this.on_query(this.$refs.QuotationOrderConfirmTable1.SetData, false)
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          }
          else
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      }
      else if (data.state == "cancel_closed") { ///撤销关闭
        let wait_close_data = _.filter(data.selected_items, (t) => t.closed == 1)
        if (wait_close_data.length == 0) {
          this.msgToasts("暂无待关闭数据！", "info")
          return
        }
        //检查是否已经关闭
        let closed_data = await QuotationTaskController.methods.getDetailData(_.map(data.selected_items, (t) => { return { id: { "=": t.quotationtask_detail_id }, closed: { "=": 2 } } }))
        if (!_.isNull(closed_data) && closed_data && closed_data.length > 0 && closed_data[0].length > 0) {
          this.msgToasts("报价已被销售关闭，请重新查询再执行该操作！", "info")
          return
        }
        let v = await this.msgModal(this.$t("notify.is_continue"))
        if (v) {
          let _result = await QuotationTaskController.methods.cancelQuoteCloseApplication(_.map(data.selected_items, (t) => { return { QuotationTaskDetailId: t.quotationtask_detail_id } }))
          if (!_.isNull(_result) && _result && _result.length > 0) {
            await this.on_query(this.$refs.QuotationOrderConfirmTable1.SetData, false)
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          }
          else
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      }
    },
    //#region 退回
    async RefusedToPurch(selected_items) {
      let dt = _.filter(selected_items, (t) => !t.SalesQuoteWeightCostApproved)
      if (dt && dt.length == 0) {
        this.msgToasts("已审批数据不能执行该操作！", "info")
        cb(false)
        return
      }
      let confirm_m = await this.$prompt('请输入退回原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\S\s]+$/,
        inputErrorMessage: '请输入原因',
      }).then(({ value }) => {
        return { state: true, val: value }
      }).catch(() => {
        return { state: false }
      })
      if (confirm_m && confirm_m.state) {
        let _list = dt.map((t) => {
          let _approve_remark = t.ApproveRemark
          if (confirm_m.val == "") _approve_remark = "退回"
          else _approve_remark = confirm_m.val
          return {
            DocumentType: "SalesQuoteWeightCost",
            ItemId: t.quotationtask_detail_id,
            Approver: t._SalesQuoteWeightCostApprover,
            ApproveRemark: _approve_remark
          }
        })
        let rt = await QuotationTaskController.methods.refusedQuotationToPurch(_list)
        if (rt) {
          this.on_query(this.$refs.QuotationOrderConfirmTable1.SetData, false)
          this.msgToasts(this.$t("notify.action_successfully"), "success")
        }
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
        return
      }
    },
    //#endregion
    ///发送邮件
    async SendEmail(data) {
      let email_user = [], ep = []
      ep = _.uniqWith(_.map(data, (t) => { return { QuotationTaskDetailId: t.quotationtask_detail_id } }), _.isEqual)
      let _result = await QuotationOrderController.methods.getData(ep)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result, (list) => {
          if (list && list.length > 0 && list[0] && list[0].fcGetSQOrderApprover)
            email_user.push(list[0].fcGetSQOrderApprover.split(",")[0])
        })
        email_user = _.uniqWith(email_user, _.isEqual)
        let p = _.map(data, (t) => { return { DetailId: t.quotationtask_detail_id, IsHomemade: '' } })
        await commonController.handleEmailNotify(p, "quote_order_confirm", this, null, "email_get_quote_data", email_user)
      }
    },
    //#endregion

    //#region 其它费用
    OtherCostEdit(code) {
      this.edit_action_code = code
      let current = this.$refs.QuotationOrderConfirmTable1.GetCurrentItem()
      if (current) {
        let dm = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { DataArea: current.dataAreaId })
        if (dm) {
          this.detail_othercost_data = []
          if (code == "other_cost") {
            let costItems = this.$store.state.biz_data.baseData.CostItems
            for (var j in costItems) {
              this.detail_othercost_data.push({ TransportCost: 0, type_code: code, CostName: costItems[j].CostName })
            }
          }
          else if (code == "exchange_rate") {
            if (current.Currency == "CNY") {
              this.msgToasts("本币无需修改！", "info")
              return
            }
            this.detail_othercost_data.push({ ExchangeRate: current.ExchangeRate, type_code: code, CostName: "汇率" })
          }
        }
        this.accessoryVisible = true
      }
      else
        this.msgToasts("请先选中行数据！", "info")
    },
    dialogOpened() {
      let current = this.$refs.QuotationOrderConfirmTable1.GetCurrentItem()
      if (this.edit_action_code == 'other_cost' && current.OtherCostJson && current.OtherCostJson != "") {
        this.detail_othercost_data = JSON.parse(current.OtherCostJson)
        _.each(this.detail_othercost_data, (t) => { t["type_code"] = this.edit_action_code })
      }
    },
    async dialogClosed() {
      let current = this.$refs.QuotationOrderConfirmTable1.GetCurrentItem()
      if (current.SalesQuoteWeightCostApproved) {
        this.msgToasts("数据已审批，不能执行该操作！", "info")
        return
      }
      let _pm = {}
      if (this.edit_action_code == 'other_cost') {
        _.each(this.detail_othercost_data, (t) => { t.TransportCost = _.toNumber(t.TransportCost) })
        current.OtherCost = _.round(_.sumBy(this.detail_othercost_data, "TransportCost"), 6)
        current.TotalCost = _.ceil(current.OtherCost / current.BatchQty, 6) + Number(parseFloat(current.WeightedCost).toFixed(10))
        current.OtherCostJson = JSON.stringify(this.detail_othercost_data)
        current.GrossProfitMargin = _.round(((current.Price_WOTax - current.TotalCost) * 100 / (current.Price_WOTax == 0 ? 1 : current.Price_WOTax)), 2)
        _pm = {
          id: current.quotationtask_detail_id,
          OtherCost: current.OtherCost,
          TotalCost: current.TotalCost,
          OtherCostJson: current.OtherCostJson
        }
      }
      if (this.edit_action_code == 'exchange_rate') {
        let _exchange_rate_update = _.toNumber(this.detail_othercost_data[0].ExchangeRate)
        let _price = current.Price == 0 ? 1 : current.Price * _exchange_rate_update
        current.ExchangeRate = _exchange_rate_update
        current.Price_WOTax = _.round(current.Price * _exchange_rate_update, 6)
        current.GrossProfitMargin = _.round(((_price - current.TotalCost) * 100 / _price), 2)
        _pm = {
          id: current.quotationtask_detail_id,
          ExchangeRateUpdate: _exchange_rate_update,
          Price_WOTax: current.Price_WOTax
        }
      }
      let p = { edit: [] }
      p.edit.push(_pm)
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.accessoryVisible = false
      }
      else
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
    },
    ///更新建议销售价
    async updatePriceSuggest() {
      let selected_items = this.$refs.QuotationOrderConfirmTable1.GetSelectedItems()
      if (selected_items.length == 0) {
        this.msgToasts("请选择要更新的数据！", "info")
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) return
      let p = { edit: [] }
      _.each(selected_items, (current) => {
        let _pm = {}
        let _exchange_rate_update = _.toNumber(current.ExchangeRate)
        let _price_suggest = (current.TotalCost / (1 - current.TargetGrossProfitMargin / 100)) / (_exchange_rate_update == 0 ? 1 : _exchange_rate_update)
        _pm = {
          id: current.quotationtask_detail_id,
          Price_Suggest: _.ceil(_price_suggest, 2)
        }
        p.edit.push(_.cloneDeep(_pm))
      })
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        let notify_list = []
        let group_selected_items = _.groupBy(selected_items, "quotation_task_create_by_username")
        for (var u in group_selected_items) {
          let email_data = {
            main: {
              Title: "",
              Url: window.location.protocol + "//" + window.location.host + "/sq/QuotationTask?tab=2",
              Url_Name: window.location.host + "/sq/QuotationTask",
            },
            items: _.orderBy(_.map(group_selected_items[u], (t) => {
              let _exchange_rate_update = _.toNumber(t.ExchangeRate)
              let _price_suggest = (t.TotalCost / (1 - t.TargetGrossProfitMargin / 100)) / (_exchange_rate_update == 0 ? 1 : _exchange_rate_update)
              return {
                QuotationTaskNum: t.QuotationTaskNum,
                QuotationTaskLineNum: t.QuotationTaskLineNum,
                ItemId: t.ItemId,
                NameAlias: t.NameAlias,
                Price: t.Price,
                TotalCost: _.ceil(t.TotalCost, 6),
                Price_Suggest: _.ceil(_price_suggest, 2)
              }
            }), ["QuotationTaskNum", "QuotationTaskLineNum"], ["desc", "asc"])
          }
          let em = commonController.excuteSendAction([u], email_data, this, "price_suggest_update")
          notify_list.push(em)
        }
        await commonController.methods.sendOrCancelNotify("add", notify_list)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
      else
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {
      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_weight_cost_confirm_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 230rem;
}
</style>
